/** Strip one pair of quotation marks the saved copy already carries, so the component's own quotes are never doubled. Display-only; stored content is untouched. */
export const unwrapQuotes = (v: string | null | undefined) => {
  const t = (v ?? "").trim();
  const m = t.match(/^["“”'‘’„«]+([\s\S]*?)["“”'‘’»]+$/);
  return m ? m[1].trim() : t;
};

